import { Dispatch } from "redux";
import { UiActions } from "../actionTypes";
import { UIActionsType } from "../types/ui/actions";

export const loadingHandler = () => (dispatch: Dispatch<UIActionsType>) => {
  dispatch({
    type: UiActions.LOADING_HANDLER,
  });
};